import { HamishonLogoArtwork } from '@/components/ui/HamishonLogoArtwork'
import styles from './navigation.module.css'

/** SVG + CSS only: the first loading frame needs no JavaScript or image request. */
export function BrandLoading({ label, lang, compact = false }: {
  label: string
  lang: 'fa' | 'en'
  compact?: boolean
}) {
  return (
    <div
      className={compact ? styles.compact : styles.page}
      role="status"
      aria-live="polite"
      data-page-loading={compact ? undefined : ''}
    >
      <div className={styles.mark} aria-hidden="true">
        <span className={styles.halo} />
        <HamishonLogoArtwork className={styles.logo} lang={lang} />
        <span className={styles.energy}><span /></span>
      </div>
      <span className={styles.label}>{label}</span>
    </div>
  )
}
